import { createRouter, createWebHistory } from 'vue-router'
import { authService } from '../services/auth'

import Daily from '../views/Daily.vue'
import All from '../views/All.vue'
import Login from '../components/Login.vue'
import Authorize from '../components/Authorize.vue'
import SetUsername from '../components/SetUsername.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: '/authorize',
    name: 'authorize',
    component: Authorize,
    meta: { requiresAuth: false },
  },
  {
    path: '/set-username',
    name: 'set-username',
    component: SetUsername,
    meta: { requiresAuth: true },
  },
  {
    path: '/daily',
    name: 'daily',
    component: Daily,
    meta: { requiresAuth: false },
  },
  {
    path: '/all',
    name: 'all',
    component: All,
    meta: { requiresAuth: true, requiresUsername: 'marco.novaes' },
  },
  {
    path: '/',
    redirect: '/daily',
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/daily',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth && to.meta.requiresUsername) {
    const currentUser = await authService.getCurrentUser()
    if (!currentUser) {
      next('/login')
      return
    }

    if (to.meta.requiresUsername && currentUser.username !== to.meta.requiresUsername) {
      next('/daily')
      return
    }
  }
  next()
})

export default router
